<template>
	<div class="open-resource" v-loading="loading">
		<div class="left-tree">
			<div class="search-box">
				<!-- <el-select v-model="tb" placeholder="请选择" size="mini" style="width: 100%; margin-bottom: 10px;">
					<el-option v-for="item in options" :key="item.tbname" :label="item.name" :value="item.tbname"> </el-option>
				</el-select> -->
				<el-input placeholder="请输入关键词" v-model="q" class="input-with-select" size="mini" @change="handleSearch">
					<el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
				</el-input>
			</div>
			<div class="search-tip" v-if="searchStatus == 2 && q && resultArr.length == 0">
				<div class="empty-tip">抱歉！暂无“{{ q }}”相关资源。</div>
				<div class="recommend-tip">您可以去右侧上报需求&nbsp;>>></div>
			</div>
			<el-tree :props="props" :load="loadNode" lazy ref="tree" node-key="nodeKey" :default-expanded-keys="defaultExpandedKeys">
				<span class="custom-tree-node" slot-scope="{ node, data }" @click="nodeClick(node, data)">
					<img
						:src="require(`@/assets/images/tree/${node.isLeaf ? 'file' : 'fileDir'}.png`)"
						class="img"
						:class="{ file: node.isLeaf }"
						alt=""
						srcset=""
					/>

					<span>{{ data.name || data.name2 }}</span>
				</span>
			</el-tree>
		</div>
		<div class="right-main">
			<demand-publish v-if="showPublish" :dataSource="dataDetail" @fileClick="nodeClick"></demand-publish>
			<file-content v-else :dataSource="dataDetail"></file-content>
		</div>

		<div class="go-back-view" title="资源首页" v-if="!showPublish" @click="dataDetail = {}">
			<i class="el-icon-s-home"></i>
		</div>
	</div>
</template>

<script>
import { StandardService } from "@/service";
import FileContent from "./file-content";
import DemandPublish from "../publish/index.vue";
let resolveFn;

export default {
	data() {
		return {
			props: {
				label: "name",
				children: "children",
				isLeaf: "isLeaf",
			},
			tb: "*",
			q: "",
			searchInput: "",
			designTbname: "",
			videoTbname: "",
			standardTbname: "standard",
			resultTbname: "result",
			techTbname: "tech",
			designLabel: "设计资料",
			videoLabel: "视频资源",
			standardLabel: "标准资源",
			resultLabel: "查询结果",
			techLabel: "技术手册",
			standard: [],
			options: [],
			defaultExpandedKeys: ["standard"],
			promiseTrigger: new Promise((resolve) => (resolveFn = resolve)),
			resultArr: [],
			dataDetail: {},
			searchStatus: 0, // 0未加载 1加载中 2加载完成
			loading: false, // 打开文件时增加全页面loading，防止点击过快
		};
	},

	components: { FileContent, DemandPublish },
	computed: {
		showPublish() {
			const { filepath, subcount, name } = this.dataDetail;
			return filepath == undefined && subcount == undefined && name == undefined;
		},
	},
	mounted() {
		this.GetStandardList();
	},
	provide() {
		return {
			handleLoading: this.handleLoading
		}
	},
	methods: {
		// 搜索
		async handleSearch() {
			if (!this.q) return;
			this.searchStatus = 1;
			this.resultArr = await this.GetSubStandardList({ tb: "*", pid: 0, q: this.q || "" });
			this.searchStatus = 2;
			this.dataDetail = this.resultArr.length
				? { name: this.resultLabel, tbname: this.resultTbname, id: this.resultTbname, isLeaf: false, code: "result" }
				: {};
			this.updateResultNode();
		},
		// 更新 查询结果 树节点
		updateResultNode() {
			this.$refs.tree.updateKeyChildren(this.resultTbname, this.resultArr);
			let resultNode = this.getResultTreeNode();
			resultNode.data.subcount = this.resultArr.length;
			resultNode.isLeaf = false;
			resultNode.expanded = true;
		},
		// 获取 查询结果 树节点
		getResultTreeNode() {
			return this.$refs.tree.getNode(this.resultTbname);
		},
		async nodeClick(node, data) {
			if (data.id === "result") {
				this.dataDetail = this.resultArr.length ? { ...data, code: "result" } : {};
			} else {
				this.dataDetail = data;
			}
		},
		// 根目录数据
		async GetStandardList() {
			let res = await StandardService.GetStandardList();
			resolveFn();
			if (res) {
				this.options = res.options;
				this.designTbname = res[this.designLabel];
				this.videoTbname = res[this.videoLabel];
				this.techTbname = res[this.techLabel];
				this.standard = res[this.standardLabel].map((item) => ({ ...item, id: item.tbname }));
			}
		},
		// 二级数据
		async GetSubStandardList(params) {
			let arr = await StandardService.GetSubStandardList(params);
			return arr
				.filter((item) => item.filepath || item.subcount)
				.map((item) => ({ ...item, tbname: params.tb, nodeKey: item.id + item.filepath + item.name, isLeaf: item.subcount === 0 }));
		},
		// 加载树节点
		async loadNode(node, resolve) {
			let { name, tbname, id } = node.data || {};

			if (node.level === 0) {
				await this.promiseTrigger;
				// 根节点
				return resolve([
					{ name: this.resultLabel, tbname: this.resultTbname, id: this.resultTbname, nodeKey: this.resultTbname, isLeaf: false },
					{ name: this.standardLabel, tbname: this.standardTbname, id: this.standardTbname, nodeKey: this.standardTbname, isLeaf: false },
					{ name: this.designLabel, tbname: this.designTbname, id: this.designTbname, nodeKey: this.designTbname, isLeaf: false },
					{ name: this.techLabel, tbname: this.techTbname, id: this.techTbname, nodeKey: this.techTbname, isLeaf: false },
					{ name: this.videoLabel, tbname: this.videoTbname, id: this.videoTbname, nodeKey: this.videoTbname, isLeaf: false },
				]);
			}

			if (node.level === 1) {
				// 标准资源
				if (name == this.standardLabel) {
					return resolve(this.standard);
				}
				// 查询结果
				if (name == this.resultLabel) {
					resolve(this.resultArr);
					node.isLeaf = false;
					return;
				}
			}
			// 二级查询
			resolve(await this.GetSubStandardList({ tb: tbname, pid: Number.isInteger(id) ? id : 0 }));
			node.isLeaf = node.isLeafByUser;
			return;
		},
		// 给子组件使用的方法
		handleLoading(status) {
			this.loading = status;
		}
	},
};
</script>

<style lang="less" scoped>

.go-back-view{
	position: fixed;
	right: 8px;
  bottom: 8px;
	width: 40px;
	height: 41px;
	z-index: 99;
	background: #ffffff;
	cursor: pointer;
	display: flex;
	justify-content: center;
	align-items: center;
	box-shadow: 0 0px 8px 2px rgba(0,0,0,0.12);
	border-radius: 4px;
	font-size: 24px;
	color: #666666;
}
.open-resource {
	font-family: Source Han Sans CN;
	display: flex;
	height: 100%;
	.left-tree {
		width: 255px;
		flex-shrink: 0;
		height: 100%;
		background-color: #fff;
		border-right: 1px solid #d6d6d6;
		display: flex;
    flex-direction: column;
		/deep/ .el-tree-node__expand-icon {
			color: #2f3748;
			&.is-leaf {
				color: transparent;
			}
		}
		/deep/ .el-tree{
			flex: 1;
			overflow-y: auto;
		}

		/deep/ .el-tree-node__content:hover {
			background-color: #e6f3f9;
			.el-tree-node__expand-icon:not(.is-leaf),
			.custom-tree-node {
				color: #0989c5;
			}
		}

		/deep/ .el-tree-node.is-current > .el-tree-node__content {
			.el-tree-node__expand-icon:not(.is-leaf),
			.custom-tree-node {
				color: #0989c5;
			}
		}

		/deep/ .el-tree-node.is-expanded > .el-tree-node__content {
			.el-tree-node__expand-icon.expanded,
			.custom-tree-node {
				color: #0989c5;
			}
		}

		/deep/ .el-tree-node:focus > .el-tree-node__content {
			background-color: #e6f3f9;
			.el-tree-node__expand-icon.expanded,
			.custom-tree-node {
				color: #0989c5;
			}
		}

		.search-box {
			padding: 10px;
			border-bottom: 1px solid rgba(214, 214, 214, 0.5);
		}

		.search-tip {
			padding: 14px;
			.empty-tip {
				font-size: 14px;
				font-weight: 500;
				color: #999999;
			}
			.recommend-tip {
				margin-top: 11px;
				font-size: 14px;
				font-weight: 500;
				color: #2f3748;
			}
		}
		.custom-tree-node {
			font-size: 14px;
			font-family: Source Han Sans CN;
			font-weight: 500;
			color: #2f3848;
			line-height: 30px;
			.img {
				width: 15px;
				margin-right: 5px;
			}
			.file {
				margin-right: 9px;
				width: 11px;
			}
		}
	}

	.right-main {
		height: 100%;
		flex: 1;
		display: flex;
		flex-direction: column;
	}
}
</style>
